// @ts-nocheck
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';
// A 5xx on token refresh is Supabase-side trouble, not a logout: retry it.
import { makeAuthRetryFetch } from '@/lib/authFetch';

const SUPABASE_URL = "https://kvttsygfutwcywroraji.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt2dHRzeWdmdXR3Y3l3cm9yYWppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA4MTU1OTUsImV4cCI6MjA4NjM5MTU5NX0.wUaZcZxKQpyk2DTzTF2CjYHvWRHa897xW0rleO6mJos";

const isRecruitLookClaimCallback =
  typeof window !== 'undefined' &&
  window.location.pathname.startsWith('/athlete-dashboard') &&
  new URLSearchParams(window.location.search).get('claimed') === '1';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !isRecruitLookClaimCallback,
  },
  global: {
    fetch: makeAuthRetryFetch(),
  },
});